/* eslint-disable react/no-unused-prop-types */
import { faInfoCircle, faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

import './Modal.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

type ModalTriggerProps = {
  modalText: string;
  onOpenModal: (props: any) => void;
  registration?: boolean;
  question: string;
  questionTitle: string;
  openModalTriggerText?: string;
};

function ModalTrigger(props: ModalTriggerProps) {
  const { t } = useTranslation();
  const randomId = Math.random().toString(36).substring(2, 15);

  function openModal(event) {
    if (props.registration) {
      event.preventDefault();
    }
    props.onOpenModal(props);
  }

  return (
    <button
      type="button"
      onClick={openModal}
      id={`modalTrigger_${props.question}`}
      className="modal_trigger_container"
      aria-labelledby={`${props.question}-help-button-${randomId}`}
    >
      <span id={`${props.question}-help-button-${randomId}`} className="visuallyHidden">
        {props.openModalTriggerText || t('MDL001')}
      </span>
      {props.registration ? (
        <FontAwesomeIcon icon={faQuestionCircle} className="rdrop_down_wtf icon" />
      ) : (
        <FontAwesomeIcon icon={faInfoCircle} className="icon modal_trigger" />
      )}
    </button>
  );
}
export default ModalTrigger;
